var _style, _path, _g, _defs, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVitaminB12Deficiency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F4A38A;}\n\t.st1{fill:#FFD680;}\n\t.st2{fill:#9E1921;}\n\t.st3{fill:#FDE6B5;}\n\t.st4{fill:#E4E5E6;}\n\t.st5{fill:#A4A7AA;}\n\t.st6{opacity:0;clip-path:url(#SVGID_2_);fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.7,180.3c42.8,0,77.6-34.4,77.6-76.9c0-42.4-34.7-76.9-77.6-76.9S28.2,61,28.2,103.4 C28.2,145.8,62.9,180.3,105.7,180.3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M105.7,80.7c-28.7,0-54.2,11-54.2,28.7c0,13.3,12.8,24.3,31.9,24.3c11,0,22.7-6.7,31-6.7c0.3,0,0.6,0,0.9,0 c12.5,0.8,12.8,11,28.7,11c7.5,0,16-6.6,16-22.1C160,96.1,137.6,80.7,105.7,80.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51.5,96.6h6.4v12.8h-6.4V96.6z M153.6,103h6.4v12.8h-6.4V103z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M144,123.1c-7.2,0-10.5-2.4-14.2-5.2c-3.4-2.5-7.3-5.4-14.2-5.8c-0.4,0-0.8,0-1.1,0c-4.6,0-9.5,1.5-14.7,3.2 c-5.5,1.7-11.1,3.5-16.3,3.5c-16.6,0-28.7-9.3-28.7-22.1c0-17.2,26.3-26.5,51.1-26.5c29.6,0,51.1,13.9,51.1,33.1 C156.8,117.9,149.1,123.1,144,123.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M105.7,72.3c27.7,0,47.9,13,47.9,30.9c0,13.2-6.6,17.7-9.6,17.7c-5.9,0-8.2-1.8-11.9-4.5 c-3.6-2.7-8.1-6-16.3-6.5c-0.5,0-0.9,0-1.4,0c-5.3,0-10.5,1.6-16,3.4c-5.2,1.6-10.5,3.3-15,3.3c-12.7,0-25.5-6.8-25.5-19.9 C57.9,80.9,82.5,72.3,105.7,72.3 M105.7,67.9c-28.7,0-54.2,11-54.2,28.7c0,13.3,12.8,24.3,31.9,24.3c11,0,22.7-6.7,31-6.7 c0.3,0,0.6,0,0.9,0c12.5,0.8,12.8,11,28.7,11c7.5,0,16-6.6,16-22.1C160,83.4,137.6,67.9,105.7,67.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M99.9,72.5c0,0,9.1-0.2,15.4,4.2c3.2,2.2,1.1,7.2,1.1,7.2l5.3,1.7c0,0-0.2-2.7,9.6-4.4 c7.2-1.3,14.5,4.4,14.5,4.4s-8.1-11-24.1-13.3C105.7,70.1,99.9,72.5,99.9,72.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M128.1,90c0,4.9-5.7,8.8-12.8,8.8c-7,0-12.8-4-12.8-8.8c0-4.9,5.7-8.8,12.8-8.8 C122.3,81.2,128.1,85.1,128.1,90"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M121.7,90c0,2.4-2.9,4.4-6.4,4.4c-3.5,0-6.4-2-6.4-4.4c0-2.4,2.9-4.4,6.4-4.4C118.8,85.6,121.7,87.6,121.7,90 "
  }))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M105.7,180.3c42.8,0,77.6-34.4,77.6-76.9c0-42.4-34.7-76.9-77.6-76.9S28.2,61,28.2,103.4 C28.2,145.8,62.9,180.3,105.7,180.3"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "28.2,107.7 183.3,107.7 192.6,154.3 151.7,191.3 105.7,200.6 22.8,190.3 22.8,124.4  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVitaminB12Deficiency);
export default __webpack_public_path__ + "static/media/Vitamin_B12_Deficiency.e39ddf2eec436647a171f66b15144b75.svg";
export { ForwardRef as ReactComponent };